export default "__VITE_ASSET__680d92f8__"